import {request} from '../http';
import domain from '../domain';

var DiscoverService = function(){
	if(domain.env === 'online'){
		this.domain = "//discover.51tiangou.com";
	}else{
		this.domain = "//discover." + domain.env + ".66buy.com.cn";
	}
};

DiscoverService.prototype._serviceAjaxCom = function(url,params){
	params.url = this.domain + url;
	return request(params);
};




/**
 * 删除发现
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {Number|String} params.data.discoverId
 * @param   {Function}      params.success
 * */
DiscoverService.prototype.delDiscover = function(params){

	params.type = 'POST';

	return this._serviceAjaxCom('/front/discover/delete', params);
};

DiscoverService.prototype.getCommentNum = function(params){
    params.type = 'GET';
    return this._serviceAjaxCom('/front/evaluation/member/num', params);
};

DiscoverService.prototype.hideEvaluation = function(params){
    params.type = 'POST';
    return this._serviceAjaxCom('/front/evaluation/hidden', params);
};

/**
 * 删除评论
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {Number|String} params.data.commentId
 * @param   {Function}      params.success
 * */
DiscoverService.prototype.delReply = function(params){

	params.type = 'POST';

	return this._serviceAjaxCom('/front/comment/delete', params);
};
/**
 * 新增评论
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {String}        params.data.content
 * @param   {Number|String} params.data.memberId
 * @param   {Number|String} params.data.discoverId
 * @param   {Number|String} params.data.sourceId
 * @param   {Number|String} params.data.replyCommentId
 * @param   {String}        params.data.replyCommentName
 * @param   {Number}        params.data.memberType
 * @param   {String}        params.data.wechatName
 * @param   {String}        params.data.wechatPhoto
 * @param   {Function}      params.success
 * */
DiscoverService.prototype.addReply = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/comment/add', params);
};

/**
 * 喜欢发现
 * @param   {Object}            params
 * @param   {Object}            params.data
 * @param   {Number|String}     params.data.discoverId
 * @param   {Number}            params.data.memberType
 * @param   {String}            params.data.wechatNickname
 * @param   {String}            params.data.wechatPhoto
 * @param   {String}            params.data.openId
 * @param   {Function}          params.success
 * */
DiscoverService.prototype.like = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/liked/selected', params);
};
/**
 * 取消喜欢发现
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {Number|String} params.data.discoverId
 * @param   {String}        params.data.openId
 * @param   {Function}      params.success
 * */
DiscoverService.prototype.likeCancel = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/liked/canceled', params);
};

/**
 * 举报发现/发现评论
 * @param   {Object}        params
 * @param   {Object}        params.data
 * @param   {Number|String} params.data.contentId
 * @param   {Number}        params.data.type        举报类型，0.发现，1.评论
 * @param   {String}        params.data.operator    举报人
 * @param   {Function}      params.success
 * */
DiscoverService.prototype.report = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/report/add', params);
};
/**
 * 关注他人
 * @param   {Object}        params
 * */
DiscoverService.prototype.concern = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/fans/concern', params);
};

/**
 * 取消关注他人
 * @param   {Object}        params
 * */
DiscoverService.prototype.unconcern = function(params){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/fans/unconcern', params);
};

/**
 * 判断用户是否为官 V
 * */
DiscoverService.prototype.isOfficeV = function(params={}){
	params.type = 'POST';

	return this._serviceAjaxCom('/front/userRole/isOfficeV', params);
};

/**
 * 查询当前订单是否已经评价过
 * */
DiscoverService.prototype.hasEvaluated = function(params){
	return this._serviceAjaxCom('/front/evaluation/check/evaluated', params);
};
/**
 * 新增商品评价
 * */
DiscoverService.prototype.releaseEvaluate = function(params){
	params.type = 'POST';
	
	return this._serviceAjaxCom('/front/evaluation/release', params);
};
/**
 * 查询专柜的商品、物流、服务评分
 * */
DiscoverService.prototype.evaluateByCounter = function(params){
	return this._serviceAjaxCom('/front/evaluation/counter/statistic', params);
};


export default new DiscoverService();